import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from "react-router-dom";
import Home from "./Home";
import TransitSecurityApp from "./TransitSecurityApp";
import DynamicTransitApp from "./DynamicTransitApp";
import CybersecurityGlossaryApp from "./CybersecurityGlossaryApp";
import ResponsibleUse from "./ResponsibleUse";
import Navbar from "./Navbar";
import { Analytics } from "@vercel/analytics/react";

function RootApp() {
  const location = useLocation();
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [showResearchTeam, setShowResearchTeam] = useState(false);

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    setShowPrivacy(!showPrivacy);
    setShowAbout(false); // Hide about when privacy is clicked
    setShowResearchTeam(false); // Hide research team when privacy is clicked
  };


  const handleResearchTeamClick = (e) => {
    e.preventDefault();
    setShowResearchTeam(!showResearchTeam);
    setShowPrivacy(false); // Hide privacy when research team is clicked
    setShowAbout(false); // Hide about when research team is clicked
  };

  return (
    <div className="min-h-screen flex flex-col">
      {location.pathname === "/" ? (
        <>
          <a href="https://www.morgan.edu/soe/ntc" target="_blank" rel="noopener noreferrer">
            <img
              src="/morgan.png"
              alt="Morgan State University Logo"
              className="global-morgan-logo"
            />
          </a>
          <a href="https://www.clemson.edu/cecas/tracr/" target="_blank" rel="noopener noreferrer">
            <img
              src="/TracRLogo.png"
              alt="TraCR Logo"
              className="global-tracr-logo"
            />
          </a>
        </>
      ) : (
        <Link to="/">
          <img
            src="/MorganLogo.png"
            alt="Morgan State University Logo - Return to Homepage"
            className="global-morgan-logo-left"
          />
        </Link>
      )}
      <Navbar />
      <main className="flex-grow p-4">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/transit-security" element={<TransitSecurityApp />} />
          <Route path="/dynamic-transit" element={<DynamicTransitApp />} />
          <Route path="/cybersecurity-glossary" element={<CybersecurityGlossaryApp />} />
          <Route path="/responsible-use" element={<ResponsibleUse />} />
        </Routes>
      </main>
      <footer className="footer">
        <div className="footer-content">
          <p>Copyright @ 2025 NTC at Morgan State University</p>
          {showAbout && (
            <div className="about-statement">
              <h4>About TraCR Foundational Project</h4>
              <p>The National Center for Transportation Cybersecurity and Resiliency (TraCR) at Morgan State University is dedicated to strengthening the security and resilience of modern transportation systems. Our work addresses the growing cyber threats facing connected and autonomous vehicles, transit infrastructure, and smart mobility networks.</p>
              <p>This foundational project focuses on identifying emerging cyber threats and implementing advanced hardening measures for <strong>Transit Security</strong> and <strong>Dynamic Transit Operations</strong>—two critical pillars of the nation's transportation infrastructure. Transit Security safeguards systems, infrastructure, and passengers through cutting-edge technologies, real-time monitoring, and rapid threat response, while Dynamic Transit Operations enables seamless, multi-modal travel by integrating advanced scheduling, dispatch, and route optimization. Our research advances beyond outdated approaches found in existing USDOT resources, introducing modern, adaptive strategies that address evolving cyber risks, enhance system resilience, and ensure safe, efficient, and reliable transportation services.</p>
            </div>
          )}
          {showPrivacy && (
            <div className="privacy-statement">
              <h2>Acknowledgement & Disclosure Statement</h2>
              <p>This work is based upon the work supported by the National Center for Transportation Cybersecurity and Resiliency (TraCR) (a U.S. Department of Transportation National University Transportation Center) headquartered at Clemson University, Clemson, South Carolina, USA. Any opinions, findings, conclusions, and recommendations expressed in this material are those of the authors and do not necessarily reflect the views of TraCR, and the U.S. Government assumes no liability for the contents or use thereof.</p>
            </div>
          )}
          {showResearchTeam && (
            <div className="research-team-statement">
              <h3>Advisory & Research Team</h3>
              <div className="team-members">
              <div className="team-member">
                <h4>Dr. Mansoureh Jeihani</h4>
                <p>Professor and Director, National Transportation Center & SMARTER Center</p>
                <p>Morgan State University</p>
              </div>
              <div className="team-member">
                <h4>Dr. Amjad Ali</h4>
                <p>Professor of Computer Science and Cybersecurity</p>
                <p>National Transportation Center & SMARTER Center</p>
                <p>Morgan State University</p>
              </div>
              <div className="team-member">
                <h4>Kushal Pokhrel</h4>
                <p>Graduate Student, Computer Science & Business Management</p>
                <p>Morgan State University</p>
              </div>
              <div className="team-member">
                <h4>Chidozie Anadozie</h4>
                <p>Graduate Student, Cybersecurity</p>
                <p>Morgan State University</p>
              </div>
              <div className="team-member">
                <h4>Dr. Ehsan Mehryaar</h4>
                <p>Data Scientist</p>
                <p>National Transportation Center | SMARTER Center</p>
                <p>Morgan State University</p>
              </div>
              </div>
            </div>
          )}
          <div className="footer-links">
            <a href="#research-team" onClick={handleResearchTeamClick}>Advisory & Research Team</a>
            <a href="#privacy" onClick={handlePrivacyClick}>Acknowledgement & Disclosure Statement</a>
            <a href="https://www.morgan.edu/soe/ntc" target="_blank" rel="noopener noreferrer">NTC</a>
            <a href="https://www.clemson.edu/cecas/tracr/" target="_blank" rel="noopener noreferrer">TraCR</a>
            <Link to="/responsible-use">Responsible Use</Link>
          </div>
        </div>
      </footer>
      <Analytics />
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <RootApp />
    </Router>
  );
}

export default AppWrapper;
